(function(angular){
	'use strict';
	
	var redemptionSurveyObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		controller: [
			RedemptionSurveyFunction
		],
		controllerAs: 'redemptionSurvey'
	};
	
	angular
		.module('redemptionRequestModule')
		.component('redemptionSurvey', redemptionSurveyObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/redemptions/redemption-survey.html';
	}
	
	function RedemptionSurveyFunction(){
		var redemptionSurvey = this;
	}
})(window.angular);